import React from "react";
import createAnalysisChart from "./CreateAnalysisChart";
import { CEO_GENDER_COLOR_MAP } from "../../../lib/constants";
import { AnalysisChartProps } from "./types";

const GenderAnalysisChart = createAnalysisChart({
  chartType: "gender",
  title: "Gender Analysis",
  legendTitle: "Genders",
  categoryField: "Gender CEO",
  colorMap: CEO_GENDER_COLOR_MAP,
  filterDeals: (deals: any[]) =>
    deals.filter((d) => {
      const gender = d["Gender CEO"] as string | undefined;
      return gender && gender.trim() && gender !== "Unknown";
    }),
  volumeLabel: "Invested capital",
  countLabel: "Number of deals",
}) as React.ComponentType<AnalysisChartProps>;

export default GenderAnalysisChart;
